import axios from "axios";

import appSettings from "../../../config/config";
const getPartnerBusinesses = async (partnerAccountId) => {
  const response = await axios.get(
    appSettings.serverlessUrl + `/api/partner/${partnerAccountId}/business/list`
  );
  return response.data.businesses || [];
};

const linkUserBusinesses = async (partnerAccountId, email) => {
  await axios.post(
    appSettings.serverlessUrl +
      `/api/partner/${partnerAccountId}/link-user-businesses`,
    {
      email: email,
    }
  );
};

const updateBusinessToPremium = async (partnerAccountId, businessDetails) => {
  await axios.post(
    appSettings.serverlessUrl +
      `/api/partner/${partnerAccountId}/business/${businessDetails.id}/update-to-premium`,
    {
      pricingSegmentId: businessDetails.pricingSegmentId,
    }
  );
};

// Send stripe link
const getPremiumLinkForBusiness = async (partnerAccountId, businessDetails) => {
  const response = await axios.post(
    appSettings.serverlessUrl +
      `/api/partner/${partnerAccountId}/business/${businessDetails.id}/create-premium-link`,
    {}
  );
  return response.data.link;
};

export default {
  getPartnerBusinesses,
  linkUserBusinesses,
  updateBusinessToPremium,
  getPremiumLinkForBusiness,
};
